import { Title, Flex } from '@mantine/core';

import { TransactionsFilter, TransactionsTable, useGetTransactions } from '@/modules/transactions';

export const Transactions = () => {
  const {
    params,
    items: transactions,
    itemsCount: transactionsCount,
    isLoading,
    handleFilterChange,
    handleFilterReset,
    handlePaginationChange,
  } = useGetTransactions();

  return (
    <>
      <Flex justify="space-between" align="center" w="100%" mb={10}>
        <Title order={4}>Транзакции</Title>
      </Flex>

      <TransactionsFilter
        onSubmit={handleFilterChange}
        onReset={handleFilterReset}
      />

      <TransactionsTable
        items={transactions}
        isLoading={isLoading}
        itemsCount={transactionsCount}
        pageSize={params.pageSize}
        currentPage={params.page}
        onPageChange={handlePaginationChange}
      />
    </>
  );
};
